<template>
  <div>
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/kim/000.gif')"
        caption="[run home] / Poster / 594 x 841 mm"
      />
      <h1>
        [run home]
      </h1>
      <p class="desc">
        런홈 포스터는 코로나 시국 우리가 지켜야 할 방역 수칙들을 주제로
        제작하였다. 늘 항상 바쁘게 뛰어다니며 살아가는 우리에게 요즘 가장 빠르게
        뛰어가야 할 곳은 집이 아닌가? 라는 생각으로부터 아이디어를 정리하여
        포스터를 제작했다. 코로나 때문에 바뀌어버리는 삶 속에서 집이 주는
        안전함이 정말로 커지고 있다. 우리 함께 방역수칙을 지켜서 코로나를
        이겨내고 코로나 시국을 잘 이겨내 가고 있는 우리에게 힘이 되는 포스터가
        되길 바란다.
      </p>
    </section>
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/kim/001.png')"
        caption="run home / Poster / A1 size (594 x 841 mm)"
      />
    </section>
    <hr />
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/kim/002.png')"
        caption="run home!"
      />
      <p class="desc">
        달리기라는 주제와 랜덤 명사 현관문을 받았을 때 이 포스터를 어떤 식으로
        풀어갈까 고민을 많이 했었다. 코로나 시국에 사는 우리가 최대한 방역수칙을
        잘 지키면서 행복한 삶을 꿈꾸길 바라며 run home 포스터를 제작하였다.
      </p>
    </section>
    <section class="mb-5">
      <image-element
        :src="require('@/assets/Projects/kim/003.png')"
        caption="Sticker / Various Sizes / Die Cutting"
      />
      <p class="desc">
        현관문의 명패에서 그래픽 모티브를 받아, 다양한 쉐잎의 스티커를 제작한다.
      </p>
    </section>
    <hr />
    <section class="mb-5">
      <image-element :src="require('@/assets/Projects/kim/004.png')" />

      <image-element
        :src="require('@/assets/Projects/kim/005.png')"
        caption="T-Shirts /  S-2XL / Black / Digital Printing"
      />
      <p class="desc">
        스티커의 그래픽을 정돈하여 집콕하며 누구나 입기편한 티셔츠를 제작한다.
      </p>
    </section>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
